var map = {
  "./cs.json": [
    "qc",
    [
      "cfk"
    ]
  ],
  "./en.json": [
    "N4J",
    [
      "r9"
    ]
  ],
  "./pl.json": [
    "UAj",
    [
      "us5"
    ]
  ],
  "./ru.json": [
    "EsC",
    [
      "ilf"
    ]
  ],
  "./tr.json": [
    "k4",
    [
      "m9"
    ]
  ],
  "./ja.json": [
    "aw",
    [
      "w8"
    ]
  ],
  "./zh.json": [
    "XrC",
    [
      "54n"
    ]
  ],
  "./pt-br.json": [
    "TYB",
    [
      "1jl"
    ]
  ],
  "./de.json": [
    "YGN",
    [
      "evi"
    ]
  ],
  "./es.json": [
    "L9",
    [
      "xw"
    ]
  ],
  "./fr.json": [
    "MY2",
    [
      "yfs"
    ]
  ],
  "./it.json": [
    "tkf",
    [
      "nr"
    ]
  ],
  "./ko.json": [
    "i9H",
    [
      "8z"
    ]
  ],
  "./pt.json": [
    "USN",
    [
      "qv"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "gV";
module.exports = __rspack_async_context;
